import { type FunctionComponent } from "react";

import cadsoftIcon from "images/Common/cadsoftIcon.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedCadsoft: FunctionComponent<IBTIconProps> = (baseProps) => {
    return <img alt="" src={cadsoftIcon} style={baseProps.style} className={baseProps.className} />;
};
